module.exports = __webpack_public_path__ + "static/media/8 ordercomplete.e7d71171.png";